import { render, staticRenderFns } from "./OrganizationSearch.vue?vue&type=template&id=0a930baa&scoped=true&"
import script from "./OrganizationSearch.vue?vue&type=script&lang=js&"
export * from "./OrganizationSearch.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSearch.vue?vue&type=style&index=0&id=0a930baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a930baa",
  null
  
)

export default component.exports